import { Box, Link, Typography } from '@mui/material';
import { FreightBillDuplicateUsageDto } from '../../../dtos';

export interface DuplicateContextListItem {
    label: string;
    href?: string;
}

export const buildDuplicateOrderReviewLinksAction = (duplicateFreightBillUsages: FreightBillDuplicateUsageDto[]) => {
    if (!duplicateFreightBillUsages.length) {
        return undefined;
    }

    return () => (
        <Box display='flex' flexDirection='column' alignItems='flex-start' gap={0.5}>
            <Typography variant='body2' color='inherit' fontWeight={600}>
                Used on Order Reviews:
            </Typography>
            {duplicateFreightBillUsages.map((usage, usageIndex) => (
                <Link
                    key={`${usage.orderReviewId}-${usageIndex}`}
                    href={`/job/${usage.jobId}/order/${usage.orderId}/orderReview/${usage.orderReviewId}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    color="inherit"
                    underline="hover"
                    variant="body2">
                    {`Open Order #${usage.orderNumber ?? 'Unknown'}${usage.orderLineItemNumber ? ` (Line Item #${usage.orderLineItemNumber})` : ''}`}
                </Link>
            ))}
        </Box>
    );
};

export const buildDuplicateContextListAction = (contextItems: DuplicateContextListItem[], heading: string) => {
    if (!contextItems.length) {
        return undefined;
    }

    return () => (
        <Box display='flex' flexDirection='column' alignItems='flex-start' gap={0.5}>
            <Typography variant='body2' color='inherit' fontWeight={600}>
                {heading}
            </Typography>
            {contextItems.map((context, contextIndex) =>
                context.href ? (
                    <Link
                        key={`${context.label}-${context.href}-${contextIndex}`}
                        href={context.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        color="inherit"
                        underline="hover"
                        variant="body2">
                        {context.label}
                    </Link>
                ) : (
                    <Typography key={`${context.label}-${contextIndex}`} variant='body2' color='inherit'>{context.label}</Typography>
                )
            )}
        </Box>
    );
};
